<template>
  <div class="mb-5">
    <img :class="[$style['image-icon'], 'left']" src="@/assets/icons/svg/at.svg"/>
    <span :class="$style['label-text']">{{ preloadedItem.name }}</span>
    <div class="input-mb input-box d-flex flex-nowrap">
      <v-text-field
        @blur="isValidatedEmailMethod"
        v-model="preloadedItem.value"
        :rules="emailRules"
        :placeholder="preloadedItem.placeholder"
        pt="5"
        :append-outer-icon="isValidatedEmail ? 'mdi-checkbox-marked-circle' : ''"
        class="r-field item-name-field custom-field-email">
        <template v-if='letDelete' slot='append'>
          <div
            :class='$style["delete-rounded-button"]'
            width='24'
            height='24'
            min-width='24'
            @click='$emit("delete")'>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color='#c3c3c3' v-bind="attrs" v-on="on">
                  mdi-close-circle
                </v-icon>
              </template>
              <span>Remove custom field</span>
            </v-tooltip>
          </div>
        </template>
      </v-text-field>
    </div>
  </div>
</template>

<script>
import { writingViewBaseMixin } from '@/components/customFields/commonMixins/_helpers/writingViewBase.mixin'
export default {
  mixins: [writingViewBaseMixin],
  data: function () {
    return {
      emailErrCnt: 0,
      emailRules: [
        (v) => {
          if (v?.length) {
            const reg = /.+@.+\..+/
            return reg.test(v) || 'Email must be valid'
          }
          return true
        }
      ]
    }
  },
  computed: {
    isValidatedEmail() {
      const reg = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i)
      return this.preloadedItem.value !== null && reg.test(this.preloadedItem.value)
    }
  },
  watch: {
    isValidatedEmail: {
      deep: true,
      handler: function (newVal) {
        this.emailErrCnt++
      }
    }
  },
  methods: {
    isValidatedEmailMethod() {
      const validRegEx = /.+@.+\..+/
      if (this.preloadedItem.value === '' || !validRegEx.test(this.preloadedItem.value)) {
        this.emailErrCnt++
      }
    }
  }
}
</script>

<style lang="scss" module src="../commonStyles/index.module.scss"></style>
